import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import useMyBusinessHook from './myBusiness-hooks';
import Loading from '../../Components/Loading/loading';
import NoData from '../../Components/NoData/noData';
import { useGeneralHooks } from '../../Hooks/hooks';
import styles from './myBusiness.module.scss';

const MyBusiness: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { type,loading, isError, renderPage } = useMyBusinessHook(+id!);
  const { navigate } = useGeneralHooks();

  useEffect(() => {
    const handlePopState = () => {
      navigate('/home?tab=business');
    };
    window.history.pushState(null, '', window.location.href);
    window.addEventListener('popstate', handlePopState);
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [navigate]);

  if (loading) {
    return (
      <div className={styles.lodingContainer}>
        <Loading />
      </div>
    );
  };

  if (isError) {
    return (
      <div className={styles.lodingContainer}>
        <NoData message="Error loading business data" />
      </div>
    );
  };

  return (
    <>
      {renderPage(type)}
    </>
  );
};

export default MyBusiness;
